import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  useNotificationSchedules,
  useUpdateNotificationSchedule,
} from '../../../features/notification-schedules/api';

const WEEKDAYS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

// On-the-hour options — the cron runs hourly, so minute granularity isn't honored.
const HOURS = Array.from({ length: 24 }, (_, h) => ({
  value: h,
  label: `${((h + 11) % 12) + 1}:00 ${h < 12 ? 'AM' : 'PM'}`,
}));

export default function WeeklyOrderReminderCard() {
  const { data: schedules, isLoading } = useNotificationSchedules();
  const update = useUpdateNotificationSchedule();

  const summary = schedules?.find((s) => s.type === 'WEEKLY_ORDER_SUMMARY');

  const [enabled, setEnabled] = useState(false);
  const [dayOfWeek, setDayOfWeek] = useState(1);
  const [hour, setHour] = useState(7);

  useEffect(() => {
    if (!summary) return;
    setEnabled(summary.enabled);
    setDayOfWeek(summary.dayOfWeek);
    setHour(summary.hour);
  }, [summary]);

  const onSave = () => {
    update.mutate(
      { type: 'WEEKLY_ORDER_SUMMARY', payload: { enabled, dayOfWeek, hour, minute: 0 } },
      {
        onSuccess: () => toast.success('Weekly reminder saved.'),
        onError: (err: any) =>
          toast.error(err?.response?.data?.error || 'Failed to save the reminder.'),
      }
    );
  };

  return (
    <div className="card">
      <h3 style={{ marginTop: 0 }}>Weekly order reminder</h3>
      <p className="muted tiny" style={{ marginTop: -6 }}>
        Emails each customer a summary of their open orders (material, load #, estimated arrival,
        status). Replies go to the customer's sales rep. Customers with no open orders are skipped.
      </p>

      {isLoading ? (
        <div className="skeleton h-40 w-full" />
      ) : (
        <>
          <label
            className="form-control"
            style={{ display: 'flex', alignItems: 'center', gap: 8, flexDirection: 'row' }}
          >
            <input
              type="checkbox"
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
            />
            <span>Send a weekly reminder</span>
          </label>

          <div className="grid grid--2">
            <div className="form-control">
              <label>Day</label>
              <select
                className="select-lg"
                value={dayOfWeek}
                disabled={!enabled}
                onChange={(e) => setDayOfWeek(Number(e.target.value))}
              >
                {WEEKDAYS.map((d) => (
                  <option key={d.value} value={d.value}>
                    {d.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-control">
              <label>Time (Eastern)</label>
              <select
                className="select-lg"
                value={hour}
                disabled={!enabled}
                onChange={(e) => setHour(Number(e.target.value))}
              >
                {HOURS.map((h) => (
                  <option key={h.value} value={h.value}>
                    {h.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="actions">
            <button className="btn btn--primary" onClick={onSave} disabled={update.isPending}>
              {update.isPending ? 'Saving…' : 'Save reminder'}
            </button>
          </div>
        </>
      )}
    </div>
  );
}
